/* eslint-disable prettier/prettier */
import React from 'react';
import { Modal, CardImg } from 'react-bootstrap'
import "../../styles/MediaPreviewer.scss"

class ImagePreviewer extends React.Component {
  constructor(props) {
    super(props)
    this.player = React.createRef()
    this.state = {}
  }

  render() {
    return (
      <Modal
        centered
        show={this.props.isOpen}
        className="mediaPreviewer"
        onHide={() => this.props.onClose()}>
        <Modal.Header closeButton/>
        <Modal.Body>
          <CardImg className='img-fluid' src={this.props.imgUrl} />
          <div className="imgName">{this.props.imgName}</div>
        </Modal.Body>
      </Modal>
    )
  }
}

export default ImagePreviewer
